import axiosClient from "../axiosInstance";

export const getBatteries = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/batteries`);

  return response.data;
};

export const getBattery = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/batteries/${id}`);

  return response.data;
};

export interface BatteryForecastParams {
  date: string; // YYYY-MM-DD
  batteryId?: number;
  batteryGroupId?: number;
}

export const getBatteryForecasts = async (
  params: BatteryForecastParams,
): Promise<any> => {
  const client = axiosClient();

  const queryParams = new URLSearchParams();
  queryParams.append("date", params.date);

  if (params.batteryId) {
    queryParams.append("batteryId", String(params.batteryId));
  }

  if (params.batteryGroupId) {
    queryParams.append("batteryGroupId", String(params.batteryGroupId));
  }

  const response = await client.get(
    `/battery-forecasts?${queryParams.toString()}`,
  );

  return response.data;
};

export interface PlannedTransactionParams {
  forecastId: number;
  plannedTransaction: number | null;
  plannedTransactionPrice: number | null;
  plannedTransactionIsExecuted: boolean | null;
}

export const savePlannedTransactions = async (
  params: PlannedTransactionParams[],
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/battery-forecasts/planned-transaction`,
    params.map((p) => ({
      forecastId: p.forecastId,
      plannedTransaction: p.plannedTransaction,
      plannedTransactionPrice: p.plannedTransactionPrice,
      plannedTransactionIsExecuted: p.plannedTransactionIsExecuted,
    })),
  );

  return response.data;
};

export const getBatteryForecastHistory = async (
  forecastId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/battery-forecasts/history?id=${forecastId}`,
  );

  return response.data;
};
